import { Card, CardContent } from "@/components/ui/card";
import { TrendingUp, TrendingDown, Wallet, DollarSign } from "lucide-react";

function StatTile({ label, value, sub, icon: Icon, tone = "neutral", testid }) {
  const toneClasses = {
    neutral: "text-foreground bg-accent/10 text-accent",
    success: "text-success bg-success/10",
    destructive: "text-destructive bg-destructive/10",
  };
  const valueClass = tone === "success" ? "text-success" : tone === "destructive" ? "text-destructive" : "text-foreground";
  return (
    <Card data-testid={testid} className="border border-border transition-colors duration-200 hover:bg-slate-50">
      <CardContent className="p-4 sm:p-6">
        <div className="flex items-center justify-between gap-3">
          <div className="space-y-1 min-w-0">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground truncate">
              {label}
            </p>
            <p className={`text-xl sm:text-2xl lg:text-3xl tracking-tight font-bold ${valueClass}`}>
              {value}
            </p>
            {sub && <p className="text-xs text-muted-foreground">{sub}</p>}
          </div>
          <div className={`p-3 rounded-md ${toneClasses[tone].split(' ').filter(c => c.startsWith('bg-')).join(' ')}`}>
            <Icon className={`h-5 w-5 sm:h-6 sm:w-6 ${toneClasses[tone].split(' ').filter(c => c.startsWith('text-')).join(' ')}`} strokeWidth={1.5} />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

function PortfolioSummaryCards({ summary, currency }) {
  if (!summary) {
    return (
      <div className="grid gap-4 grid-cols-2 lg:grid-cols-4 mb-8">
        {[1, 2, 3, 4].map((i) => (
          <Card key={i} className="border border-border">
            <CardContent className="p-6">
              <div className="h-20 animate-pulse bg-muted rounded" />
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  const fmt = (n) => `${currency} ${n.toFixed(2)}`;
  const unrealizedTone = summary.total_unrealized_pnl >= 0 ? "success" : "destructive";
  const realizedTone = summary.total_realized_pnl >= 0 ? "success" : "destructive";

  return (
    <div className="grid gap-4 grid-cols-2 lg:grid-cols-4 mb-8">
      <StatTile
        testid="summary-portfolio-value"
        label="Portfolio Value"
        value={fmt(summary.total_market_value)}
        icon={Wallet}
      />
      <StatTile
        testid="summary-total-invested"
        label="Total Invested"
        value={fmt(summary.total_invested)}
        icon={DollarSign}
      />
      <StatTile
        testid="summary-unrealized-pnl"
        label="Unrealized P&L"
        value={fmt(summary.total_unrealized_pnl)}
        icon={summary.total_unrealized_pnl >= 0 ? TrendingUp : TrendingDown}
        tone={unrealizedTone}
      />
      <StatTile
        testid="summary-realized-pnl"
        label="Realized P&L"
        value={fmt(summary.total_realized_pnl)}
        icon={summary.total_realized_pnl >= 0 ? TrendingUp : TrendingDown}
        tone={realizedTone}
      />
    </div>
  );
}

export default PortfolioSummaryCards;
